import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'María Laura',
  location: 'Buenos Aires',
  rating: 5,
  text: 'Siempre le tuve terror a la electricidad. Con esta guía pude cambiar todos los enchufes viejos de mi casa sin llamar a nadie. ¡Súper claro todo el paso a paso!'
}, {
  name: 'Florencia',
  location: 'Córdoba',
  rating: 5,
  text: 'Me ahorré un montón de plata. El electricista me cobraba una fortuna solo por venir a ver un cortocircuito. Con el tomo de problemas eléctricos lo resolví en una tarde.'
}, {
  name: 'Camila',
  location: 'Rosario',
  rating: 5,
  text: 'Vivo sola y me cansé de depender de otros para arreglar las cosas de mi casa. Las explicaciones son a prueba de tontos, hasta yo que no sabía nada pude instalar una lámpara nueva.'
}, {
  name: 'Sofía',
  location: 'Mendoza',
  rating: 4,
  text: 'Compré el plan premium y valió cada centavo. Los diagramas son muy fáciles de entender. Ya arreglé dos llaves de luz que no andaban y me siento súper segura haciéndolo.'
}, {
  name: 'Valentina',
  location: 'La Plata',
  rating: 5,
  text: 'Me sentí re empoderada. Nunca pensé que iba a poder hacer mantenimiento eléctrico. El manual es excelente, te saca el miedo y te explica las medidas de seguridad perfecto.'
}, {
  name: 'Luciana',
  location: 'Mar del Plata',
  rating: 5,
  text: 'Lo mejor es que lo tenés en el celu y lo vas mirando mientras trabajás. Cambié el timbre y arreglé un tomacorriente que hacía falso contacto. ¡Recomendadísimo para cualquier mujer!'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-white px-4 relative" data-id="element-243">
      <div className="max-w-6xl mx-auto" data-id="element-244">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-245">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-50 text-brand-600 font-bold text-sm mb-4 border border-brand-100" data-id="element-246">
            Casos de Éxito
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-extrabold mb-4 text-gray-900" data-id="element-247">
            💬 Lo que dicen nuestras clientas
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-248">
            Mujeres de todo el país ya están resolviendo los problemas
            eléctricos de sus casas sin depender de nadie.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-249">
          {testimonials.map((testimonial, index) => <motion.div key={index} className="bg-white rounded-3xl p-8 border border-gray-100 shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:shadow-[0_4px_25px_rgba(0,0,0,0.06)] transition-shadow" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-250">
              <div className="flex items-center gap-4 mb-4" data-id="element-251">
                <div className="w-14 h-14 rounded-full bg-brand-100 text-brand-600 flex items-center justify-center font-heading font-bold text-2xl flex-shrink-0" data-id="element-252">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-253">
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-254">
                    {testimonial.name}
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-255">
                    de {testimonial.location}
                  </p>
                </div>
                <div className="ml-auto flex gap-0.5" data-id="element-256">
                  {[...Array(5)].map((_, i) => <Star key={i} className={`w-4 h-4 ${i < testimonial.rating ? 'fill-yellow-400 text-yellow-400' : 'fill-gray-200 text-gray-200'}`} data-id="element-257" />)}
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed italic" data-id="element-258">
                "{testimonial.text}"
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}